export const materialTypes = {
	BRONZE: 'BRONZE',
	IRON: 'IRON',
	STEEL: 'STEEL',
	MITHRIL: 'MITHRIL',
	ADAMANTIUM: 'ADAMANTIUM',
	ORICHALCUM: 'ORICHALCUM',
	VULCANITE: 'VULCANITE',
	AQUANITE: 'AQUANITE',
	VRONITE: 'VRONITE',
	LOULOUDIUM: 'LOULOUDIUM',
	ILIOTIUM: 'ILIOTIUM',
	LEVANTIUM: 'LEVANTIUM'
}

export const itemTypes = {
	ARMOR: 'ARMOR',
	AMMUNITION: 'AMMUNITION',
	WEAPONS: 'WEAPONS',
	BOOKS: 'BOOKS',
	POTIONS: 'POTIONS',
	MISCELLANEOUS: 'MISCELLANEOUS'
}

export const wallTypes = {
	LIGHT_STONE: 'LIGHT_STONE',
	STONE: 'STONE',
	DARK_STONE: 'DARK_STONE',
	DARKER_STONE: 'DARKER_STONE',
	LIGHT_DIRT: 'LIGHT_DIRT',
	DIRT: 'DIRT',
	DARK_DIRT: 'DARK_DIRT',
	DARKER_DIRT: 'DARKER_DIRT',
	LIGHT_WOOD: 'LIGHT_WOOD',
	WOOD: 'WOOD',
	DARK_WOOD: 'DARK_WOOD',
	DARKER_WOOD: 'DARKER_WOOD',
	LIGHT_COLD_DIRT: 'LIGHT_COLD_DIRT',
	COLD_DIRT: 'COLD_DIRT',
	DARK_COLD_DIRT: 'DARK_COLD_DIRT',
	DARKER_COLD_DIRT: 'DARKER_COLD_DIRT',
	LIGHT_MINE: 'LIGHT_MINE',
	MINE: 'MINE',
	DARK_MINE: 'DARK_MINE',
	DARKER_MINE: 'DARKER_MINE',
	LIGHT_HOT_DIRT: 'LIGHT_HOT_DIRT',
	HOT_DIRT: 'HOT_DIRT',
	DARK_HOT_DIRT: 'DARK_HOT_DIRT',
	DARKER_HOT_DIRT: 'DARKER_HOT_DIRT',
	LIGHT_COLD_WOOD: 'LIGHT_COLD_WOOD',
	COLD_WOOD: 'COLD_WOOD',
	DARK_COLD_WOOD: 'DARK_COLD_WOOD',
	DARKER_COLD_WOOD: 'DARKER_COLD_WOOD',
	LIGHT_MOSSY_STONE: 'LIGHT_MOSSY_STONE',
	MOSSY_STONE: 'MOSSY_STONE',
	DARK_MOSSY_STONE: 'DARK_MOSSY_STONE',
	DARKER_MOSSY_STONE: 'DARKER_MOSSY_STONE'
}

export const floorTypes = {
	COLD_STONE: 'COLD_STONE',
	STONE: 'STONE',
	DARK_STONE: 'DARK_STONE',
	DARKER_STONE: 'DARKER_STONE',
	LIGHT_DIRT: 'LIGHT_DIRT',
	DIRT: 'DIRT',
	DARK_DIRT: 'DARK_DIRT',
	DARKER_DIRT: 'DARKER_DIRT',
	LIGHT_GRASS: 'LIGHT_GRASS',
	GRASS: 'GRASS',
	DARK_GRASS: 'DARK_GRASS',
	DARKER_GRASS: 'DARKER_GRASS',
	LIGHT_WOOD: 'LIGHT_WOOD',
	WOOD: 'WOOD',
	DARK_WOOD: 'DARK_WOOD',
	DARKER_WOOD: 'DARKER_WOOD',
	COLD_COBBLESTONE: 'COLD_COBBLESTONE',
	COBBLESTONE: 'COBBLESTONE',
	DARK_COBBLESTONE: 'DARK_COBBLESTONE',
	DARKER_COBBLESTONE: 'DARKER_COBBLESTONE'
}
